const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/invoices/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/invoices/")({
  beforeLoad: args => requirePermission(Permissions.Invoices.Manage, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
export function InvoiceStatusBadge({
  status
}: {
  status: InvoiceStatus;
}) {
  const colors: Record<InvoiceStatus, string> = {
    Draft: "bg-gray-100 text-gray-700",
    Open: "bg-blue-100 text-blue-700",
    Paid: "bg-green-100 text-green-700",
    Void: "bg-gray-200 text-gray-500 line-through",
    Uncollectible: "bg-red-100 text-red-700"
  };
  return <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${colors[status]}`}>
      {status}
    </span>;
}